import { urlsWrapper, urls } from 'config';
import { serialize, sortListByImportantAndName } from 'utils';
import { createSelector } from 'reselect';

import {
  saveData,
  createCommonListConstants,
  createCommonListReducer,
} from './utils';
import { commonPost, commonDelete, commonPut, commonGet } from './api';
import shareInFlight from './inFlight';

const constants = createCommonListConstants('FIELDS');

// reducer
export default createCommonListReducer(constants, sortListByImportantAndName);

// actions
const FIELDS_PARAMS = { include: 'normal,bare', embed: 'geometries' };

const getFieldsUrl = (params) =>
  `${urlsWrapper('fields')}${params ? `?${serialize(params)}` : ''}`;

export function getFields(params = FIELDS_PARAMS) {
  return saveData(
    getFieldsUrl(params),
    constants.SET_LIST,
    constants.SET_IS_PENDING
  );
}

// The application start and the map screen opened with it read the same
// list: they share the request in flight. Reads after a change use
// getFields, which always starts a new request.
export const loadFields =
  (params = FIELDS_PARAMS) =>
  (dispatch) => {
    const key = `${getFieldsUrl(params)} ${localStorage.getItem('JWT_REFRESH')}`;
    return shareInFlight(dispatch, key, () => dispatch(getFields(params)));
  };

export function getAvailableFieldsByUser(
  userId,
  params = { include: 'normal,bare' }
) {
  return commonGet({
    url: `${urls(userId).fields}${params ? `?${serialize(params)}` : ''}`,
  });
}

const shouldFetchFields = (state) => state.fields.list.length === 0;

export const fetchFieldsIfNeeded = (embedParam) => (dispatch, getState) =>
  shouldFetchFields(getState())
    ? dispatch(getFields(embedParam))
    : Promise.resolve();

export const deleteField = (fieldId) => () =>
  commonDelete({ url: `${urlsWrapper('fields')}/${fieldId}` });

export const addField = (data) => () =>
  commonPost({ url: `${urlsWrapper('fields')}`, data, name: 'поле' });

export const updateField =
  (fieldId, data, isSync = true) =>
  () =>
    commonPut({
      url: `${urlsWrapper('fields')}/${fieldId}${
        isSync ? '' : '?syncicons=false'
      }`,
      data,
      name: 'поле',
    });

export const updateSowings = (fieldId, data, errorMessage) => () =>
  commonPost({
    url: `${urlsWrapper('fields')}/${fieldId}/sowings`,
    data,
    name: 'посев',
    errorMessage,
  });

// selectors
export const getFieldsSelector = createSelector(
  [(state) => state.fields.list, (state) => state.fields.isPending],
  (list, isPending) => ({
    list,
    isPending,
  })
);

export function getField(fieldId) {
  return commonGet({
    url: `${urlsWrapper('fields')}/${fieldId}`,
  });
}
